<template>
  <div class="bottom-charts">
    <div class="bc-chart-item">
      <div class="bcci-header">是否一窗受理</div>
      <dv-active-ring-chart :config="config1" />
      <Label-Tag :config="labelConfig1" />
    </div>
    <dv-decoration-2 class="decoration-1" :reverse="true" style="width:5px;" />

    <div class="bc-chart-item">
      <div class="bcci-header">是否自建系统</div>
      <dv-active-ring-chart :config="config2" />
      <Label-Tag :config="labelConfig2" />
    </div>

    <dv-decoration-2 class="decoration-2" :reverse="true" style="width:5px;" />

    <div class="bc-chart-item">
      <div class="bcci-header">是否一次办好</div>
      <dv-active-ring-chart :config="config3" />
      <Label-Tag :config="labelConfig3" />
    </div>
  </div>
</template>

<script>
import LabelTag from './LabelTag'

export default {
  name: 'BottomCharts22',
  components: {
    LabelTag
  },
  data() {
    return {
      config1: {
        data: [
          {
            name: '',
            value: 34852
          },
          {
            name: '',
            value: 42668
          }
        ],
        radius: '70%', activeRadius: '70%', activeTimeGap: 100000,
        showOriginValue: false,
        digitalFlopStyle: {
          fontSize: 0,
        }, color: ['#00baff', '#3de7c9', '#ffc530', '#469f4b']
      },

      config2: {
        data: [
          {
            name: '',
            value: 3092
          },
          {
            name: '',
            value: 10027
          },
          {
            name: '',
            value: 64401
          },

        ],
        radius: '70%', activeRadius: '70%', activeTimeGap: 100000,
        showOriginValue: false,
        digitalFlopStyle: {
          fontSize: 0,
        }, color: ['#00baff', '#3de7c9', '#ffc530', '#469f4b']
      },

      config3: {
        data: [
          {
            name: '',
            value: 77376
          },
          {
            name: '',
            value: 144
          },
        ],
        radius: '70%', activeRadius: '70%', activeTimeGap: 100000,
        showOriginValue: true,
        digitalFlopStyle: {
          fontSize: 0,
        }, color: ['#00baff', '#3de7c9', '#ffc530', '#469f4b']
      },
      labelConfig1: {
        data: ['是:34852', '否:42668'],
      },
      labelConfig2: {
        data: ['是:3092', '否:10027', '无系统:64401'],
      },
      labelConfig3: {
        data: ['是:77376', '否:144'],
      }
    }
  }
}
</script>

<style lang="less">
.bottom-charts {
  width: 100%;
  height: 40%;
  display: flex;
  position: relative;

  .bc-chart-item {
    width: 32%;
    height: 60%;
    padding-top: 10px;
    box-sizing: border-box;
  }

  .bcci-header {
    height: 20px;
    text-align: center;
    line-height: 20px;
    font-size: 16px;
  }

  .dv-active-ring-chart {
    height: calc(~"100% - 20px");
    color: #000;
  }

  .label-tag {
    height: 10px;
    color: #000;
  }

  .active-ring-name {
    font-size: 14px !important;
  }

  .decoration-1,
  .decoration-2,
  .decoration-3 {
    display: absolute;
    left: 0%;
  }
}
</style>
